import validationFunctions from '../../utils/validation';

const functions = validationFunctions;

export const validators = {
  Birthdate__c: functions.validateDate,
  validateInput: functions.validateInput,
};
